import { ITag } from '@models/Tag.model';
import { MaybeUndef } from '@pages/Asset/components/Legacy/AddField/AddField.types';

export function getTagTip(isTag: MaybeUndef<boolean>, isCustomField?: boolean) {
  if (isTag) return 'Sorting by Tags is coming soon';
  if (isCustomField) return 'Sorting by Custom Fields is coming soon';
  return '';
}
/**
 * Sorts an array of tags,
 *
 * It Can be generalised for any obj with a string val. E.g: `sortListByProp<A>(list: A[], property: OmitNonStringVals<A,keyof A>)`.
 *
 * OmitNonStringVals is a generic that only allows keys whose values are strings.
 */
export function sortTags(tags: ITag[]): ITag[] {
  const tagCopy = [...tags];
  return tagCopy.sort((a, b) => {
    // Upper C < lower a.
    const stdA = a.name.toLowerCase();
    const stdB = b.name.toLowerCase();
    if (stdA < stdB) return -1;
    if (stdA === stdB) return 0;
    return 1;
  });
}
